import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { CaslSubject } from '../../authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../base/dtos/base.dto';
import { VehicleMakeListDto } from '../../vehicle-makes/dtos/vehicle-make-list.dto';

/**
 * Vehicle model DTO for lists
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehicleModelListDto extends BaseDto {
	name!: string;
	externalReference?: string;
	make!: VehicleMakeListDto;

	mobileTitle = (): string | null => {
		return `${this.name}`;
	};

	mobileSubtitle = (): string | null => {
		return `${this.make.name}`;
	};
}
